import axios from 'axios'
import i18n from '@/plugins/i18n'

// Модель для работы с путевками
export default {
  // Получение списка бсо для департамента
  getBsoList (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/voucher/getBsos?${filter}`)
  },
  // Получение списка
  getList (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/voucher/getVouchers?${filter}`)
  },
  // Получение данных для формы поиска
  getVoucherFilterFormData () {
    return axios.get(`${i18n.locale}/api/voucher/getVoucherFilterFormData`)
  },
  // Просмотр
  getVoucherInfo (id) {
    return axios.get(`${i18n.locale}/api/voucher/getVoucherInfo/${id}`)
  },
  // Выдача
  issueVoucher (id, data) {
    return axios.post(`${i18n.locale}/api/voucher/issueVoucher/${id}`, data)
  },
  // Редактирование ООПТ
  editVoucherOopt (id, data) {
    return axios.post(`${i18n.locale}/api/voucher/editVoucherOopt/${id}`, data)
  },
  // Получение данных для формы редактирования
  getVoucherFormData (id) {
    return axios.get(`${i18n.locale}/api/voucher/getVoucherFormData/${id}`)
  },
  // Редактирование
  editVoucher (id, statusId, data) {
    return axios.post(`${i18n.locale}/api/voucher/editVoucher/${id}/${statusId}`, data)
  },
  // Список действий
  getActions (statusId) {
    return axios.get(`${i18n.locale}/api/voucher/actions/${statusId}`)
  },
  // Изменение статуса
  changeStatus (id, data) {
    return axios.post(`${i18n.locale}/api/voucher/changeStatus/${id}`, data)
  }
}
